import { getMomentDate } from '../utils/commonUtils';
import BaseModel from './BaseModel';
import { RATECODE, SUPPLIER } from '../constants/Define';
export default class Supplier extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = this.__data__) {
        this.id = data.id || undefined;
        this.supplierName = data.supplierName || undefined;
        this.address = data.address || this.translate.address || undefined;
        this.email = data.email || undefined;
        this.logo = data.logo || undefined;
        this.logoImage = data.logoImage || undefined;
        this.noteContent = data.noteContent || this.translate.noteContent || undefined;
        this.phoneNumber = data.phoneNumber || undefined;
        this.taxNumber = data.taxNumber || undefined;
        this.contactFullname = data.contactFullname || undefined;
        this.contactEmail = data.contactEmail || undefined;
        this.contactPhoneNumber = data.contactPhoneNumber || undefined;
        this.contractStatus = data.contractStatus || SUPPLIER.CONTRACT.STATUS.UNSIGNED.id;
        this.contractNumber = data.contractNumber || undefined;
        this.signedDate = getMomentDate(data.signedDate);
        this.contractEndDate = getMomentDate(data.contractEndDate);
        this.code = data.code || undefined;
        this.website = data.website || undefined;
        this.question = data.question || undefined;
        this.answer = data.answer || undefined;
        this.addressHyperLink = data.addressHyperLink || undefined;
        this.position = data?.position || {
            lat: data.latitude || 10.338477031630134,
            lng: data.longtitude || 103.89193985742187,
            };
        this.zoom = data.zoom || 1;
        // for vinwonder
        this.supplierType = data.supplierType || undefined;
        this.isEnableVinwonder = data.supplierType === RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id ? true : false;
        this.siteCode = this.isEnableVinwonder ? data.siteCode : undefined;
        this.propertyCode = this.isEnableVinwonder ? data.propertyCode : undefined;
        this.title = this.isEnableVinwonder ? (data.title || this.translate.title)  : undefined;
        this.tripAdvisorCode = this.isEnableVinwonder ? data.tripAdvisorCode: undefined;
        this.shortDescription = this.isEnableVinwonder ? (data.shortDescription || this.translate.shortDescription) : undefined;
        this.mainStatus = this.isEnableVinwonder ? (data.mainStatus || this.translate.mainStatus): undefined;
        this.thumbImage = this.isEnableVinwonder ? data.thumbImage : undefined;
        this.specialImage = this.isEnableVinwonder ? data.specialImage: undefined;
        this.slideShowImages = this.isEnableVinwonder ? (data.slideShowImages?.object || data.slideShowImages) : undefined;
        this.video = this.isEnableVinwonder ? data.video: undefined;
        this.extraInfos = this.translate.extraInfos || this.initExtraInfos();
        // end - vinwonder
        this.saleDateType = data.saleDateType;
        this.saleDateValues = data.saleDateValues;
        this.saleStartDate = getMomentDate(data.saleStartDate);
        this.fnbPropertyId = data.fnbPropertyId || undefined;

        this.setSupplierProduct(data);
    }

    initExtraInfos() {
        return [
            { title: 'Thông tin chung', content: '' },
            { title: 'Điều khoản chung', content: '' },
            { title: 'Hướng dẫn sử dụng', content: '' }
        ]
    }

    setSupplierProduct(data = {}) {
        this.supplierProduct = data.supplierProductId && new SupplierProduct({ id: data.supplierProductId });
    }

    setLogo(url, name) {
        this.logo = url;
    }

    removeLogo(url) {
        this.logo = undefined;
    }

    export(hasTranslate = false) {
        const result = super.export({
            id: this.id,
            supplierName: this.supplierName,
            address: this.address,
            email: this.email,
            logo: this.logo,
            logoImage: this.logoImage,
            noteContent: this.noteContent,
            phoneNumber: this.phoneNumber,
            contactEmail: this.contactEmail,
            taxNumber: this.taxNumber,
            contactFullname: this.contactFullname,
            commonUtils: this.contactEmail,
            contactPhoneNumber: this.contactPhoneNumber,
            contractStatus: this.contractStatus,
            contractNumber: this.contractNumber,
            signedDate: this.signedDate && this.signedDate.toISOString(),
            contractEndDate: this.contractEndDate && this.contractEndDate.toISOString(),
            supplierProductId: this.supplierProduct && this.supplierProduct.id,
            code: this.code,
            website: this.website,
            question : this.question,
            answer : this.answer,

            // for vinwonder
            siteCode: this.isEnableVinwonder ? this.siteCode : undefined,
            propertyCode: this.isEnableVinwonder ? this.propertyCode : undefined,
            title: this.isEnableVinwonder ? this.title : undefined,
            tripAdvisorCode: this.isEnableVinwonder ? this.tripAdvisorCode : undefined,
            shortDescription: this.isEnableVinwonder ? this.shortDescription : undefined,
            mainStatus: this.isEnableVinwonder ? this.mainStatus : undefined,
            thumbImage: this.isEnableVinwonder ? this.thumbImage: undefined,
            specialImage: this.isEnableVinwonder ? this.specialImage: undefined,
            slideShowImages: this.isEnableVinwonder ? this.slideShowImages: undefined,
            supplierType: this.isEnableVinwonder ? RATECODE.GROUP_TYPE_VINWONDER.VINWONDER.id : undefined,
            video: this.isEnableVinwonder ? this.video : undefined,
            extraInfos: this.isEnableVinwonder ? this.extraInfos : undefined,
            // end - vinwonder
            languageCode: this.languageCode,
            addressHyperLink: this.addressHyperLink,
            longtitude: this.position.lng,
            latitude: this.position.lat,
            zoom: this.zoom,
            saleDateType: this.saleDateType,
            saleDateValues: this.saleDateValues,
            saleStartDate: this.saleStartDate && this.saleStartDate.toISOString(),
            fnbPropertyId: this.fnbPropertyId,
        });
        if (hasTranslate) result.translate = () => {
            return {
                id: this.translate.id,
                supplierId: this.translate.supplierId || this.supplierId || this.id,
                title: this.title,
                shortDescription: this.shortDescription,
                description: this.description,
                mainStatus: this.mainStatus,
                noteContent: this.noteContent,
                languageCode: this.languageCode,
                extraInfos: this.extraInfos,
                address: this.address,
            }
        }

        return result;
    }

}

export class SupplierProduct extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.id = data.id || undefined;
        this.supplierId = data.supplierId || undefined;
        this.name = data.name || undefined;
        this.productCode = data.productCode || undefined;
        this.supplierTypes = data.supplierTypes || [];
        this.supplierType = data.supplierType || [];
        this.cost = data.cost || undefined;
        this.description = data.description || undefined;
        // this.sellCost = data.sellCost || undefined;
        this.type = data.type || undefined;
        this.transactionCode = data.transactionCode || undefined;
        this.supplierName = data.supplierName || undefined;
        this.categoryId = data.categoryId || undefined;
        this.categoryName = data.categoryName || undefined;
        this.keyLists = data.keyLists || undefined;
        this.isActive = data.isActive || false;
        this.productType = data.productType || undefined;
        this.supplierProductType = data.supplierProductType || undefined;
        this.refID = data.refID || undefined;
        this.rateCode = data.rateCode || undefined;
        this.hotelIds = data.hotelIds || [];
    }

    export(hasTranslate = false) {
        const result = {
            id: this.id,
            supplierId: this.supplierId,
            name: this.name,
            productCode: this.productCode,
            supplierTypes: this.supplierTypes,
            cost: this.cost,
            description: this.description,
            // sellCost: this.sellCost,
            type: this.type,
            transactionCode: this.transactionCode,
            supplierName: this.supplierName,
            categoryId: this.categoryId,
            keyLists: this.keyLists,
            isActive: this.isActive,
            productType: this.productType,
            supplierProductType: this.supplierProductType,
            refID: this.refID,
            rateCode: this.rateCode,
            hotelIds: this.hotelIds
        }
        if (hasTranslate) result.translate = () => {
            return {
                supplierId: this.supplierId,
                description: this.description,
                name: this.name,
            }
        }
        return result;
    }
}

export class SupplierUsagePlan extends BaseModel {
    constructor(data = {}) {
        super(data);
        this.setData(data)
    }

    setData(data = {}) {
        this.productCode = data.productCode || undefined;
        this.productWarehouseGoodReceipts = data.productWarehouseGoodReceipts || [];
        this.supplierProductUsagePlans = data.supplierProductUsagePlans || [];
    }

    export() {
        const result = {
            productCode: this.productCode,
            productWarehouseGoodReceipts: this.productWarehouseGoodReceipts,
            supplierProductUsagePlans: this.supplierProductUsagePlans,
        }
        return result;
    }
}
